// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HDV1","index":"styles_index__4wQhN"};